import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const DiveBoardHigh = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="dive-board-high"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.578 12.872h2.93c0-3.231-2.629-5.86-5.86-5.86-1.748 0-3.32.772-4.394 1.99a5.846 5.846 0 00-4.395-1.99A5.866 5.866 0 005 12.872h.023v40.116h2.884v-2.665h5.882v2.665h2.93V12.872a2.933 2.933 0 012.93-2.93 2.933 2.933 0 012.93 2.93zM10.86 9.942c1.398 0 2.57.984 2.86 2.295h-5.72a2.934 2.934 0 012.86-2.295zm2.93 37.451H7.907v-2.93h5.882v2.93zm0-5.86H7.907v-2.929h5.882v2.93zm0-5.858H7.907v-2.93h5.882v2.93zm0-5.86H7.907v-2.93h5.882v2.93zm0-5.86H7.907v-2.929h5.882v2.93zm0-5.859H7.907v-2.93h5.882v2.93zM54.971 45.715a4.726 4.726 0 00-6.684 0l-.014.014-.015.015a4.726 4.726 0 01-6.684 0l-.014-.014-.015-.015a4.726 4.726 0 00-6.684 0l-.014.014-.015.015a4.726 4.726 0 01-6.684 0l-.014-.014-.015-.015a4.726 4.726 0 00-6.684 0l-.014.014-.015.015a4.705 4.705 0 01-1.758 1.11v6.134H55v-7.244l-.029-.029z" />
      <path d="M19 15h27v1a3 3 0 01-3 3H19v-4z" />
    </svg>
  );
};
/* eslint-enable max-len */

DiveBoardHigh.defaultProps = {
  className: null,
};

DiveBoardHigh.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default DiveBoardHigh;
